import React from "react"
import ReactTooltip from "react-tooltip"
import concatWithSpaces from "components/ProjectNonSpecificComponents/Functions/concatWithSpaces"
import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import { Th, THead, Tr } from "./StyledComponents/TableStyleComp"
import Icon from "components/ProjectSpecificComponents/Elements/Global/atoms/Icons/Icon/Icon"

interface Props {
	head: any
	requestSort: (key: string, type: string) => void
	getClassNamesFor: (name: string) => any
	sortable?: boolean
	tableHeadStyle?: React.CSSProperties
}

export default function TableHead({
	head,
	requestSort,
	getClassNamesFor,
	sortable,
	tableHeadStyle,
}: Props) {
	return (
		<THead style={{ ...tableHeadStyle }}>
			<Tr>
				{Object.keys(head).map((Name) => {
					const isRowSortable: boolean = sortable || head[Name].sortable
					return (
						<Th
							className={concatWithSpaces(
								getClassNamesFor(head[Name].key),
								isRowSortable ? "pointer" : ""
							)}
							onClick={() => isRowSortable && requestSort(head[Name].key, head[Name]?.type)}
							key={Name}
						>
							<div className="flex-row center-y" style={{ justifyContent: "space-between" }}>
								<ReactTooltip id={head[Name].key} />
								<label
									className={isRowSortable ? "pointer" : ""}
									data-tip={head[Name].tooltip}
									data-for={head[Name].key}
								>
									{head[Name].label}
								</label>

								{isRowSortable && (
									<HyperDiv direction="column">
										<Icon iconKey="arrow-up" iconColor="#616266" />
										<Icon iconKey="arrow-down" iconColor="#616266" />
									</HyperDiv>
								)}
							</div>
						</Th>
					)
				})}
			</Tr>
		</THead>
	)
}
